export default {
    eventTypes:      { method: 'get',    url: 'event_types' },
    createEventType: { method: 'post',   url: 'event_types'},
    updateEventType: { method: 'put',    url: 'event_types/{id}'},
    deleteEventType: { method: 'delete', url: 'event_types/{id}'}
}